import fr_CA from '../../translations/fr_CA.json';

export const defaultLanguage = 'en';

export const languages = {
  'en': 'English',
  'fr_CA': 'Français canadien'
}

const g_translations = {
  fr_CA
}

export function withDefaultLanguageIfNotPresent(session) {
  if (!session) return session;
  return {language: 'en', ...session}
}

export function i18nData(data) {
  if (typeof data !== 'object') throw new TypeError('wrong data type');
  data.$tag = 'i18n';
  return data;
}

export function i18nProvider(provider) {
  if (typeof provider !== 'function') throw new TypeError('wrong provider type');
  provider.$tag = 'i18n';
  return provider;
}

export function i18nExtend(lang, translations) {
  Object.assign(g_translations[lang], translations)
}

export function i18n(lang = defaultLanguage) {
  if (typeof lang !== 'string') throw new TypeError('lang must be a string');

  const data = g_translations[lang] || {};
  const fn = (arg1, ...args) => {
    switch(typeof arg1) {
      case 'string': {
        return data[arg1] || arg1;
      }
      case 'function': {
        if ('i18n' !== arg1.$tag) return arg1;
        return arg1(lang);
      }
      case 'object': {
        if (arg1.$tag === 'i18n') return arg1[lang] || arg1[defaultLanguage];
        if (!Array.isArray(arg1)) return arg1;
        if (arg1.length === 1) return data[arg1[0]] || arg1[0];
        const key = arg1.join('${}');
        const value = data[key];
        if (value) {
          return value.replace(/\$(\d)/g, function (match, index) {
            return args[index] || '';
          });
        }
        let a = [];
        let i = 0;
        for (const c of arg1) {
          a.push(data[c] || c);
          a.push(args[i++] || '');
        }
        return a.join('');
      }
      default:
        return arg1;
    }
  }
  fn.lang = lang;
  return fn;
}



// WEBPACK FOOTER //
// ./src/helpers/i18n.js